module.exports = __webpack_public_path__ + "static/img/ba.06a5954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ba.png
// module id = faa4
// module chunks = 1